// extracted by mini-css-extract-plugin
export var brand = "_91-9";
export var compact = "_91-6";
export var extraSmall = "_91-7";
export var icon = "_91-0";
export var large = "_91-4";
export var light = "_91-1";
export var medium = "_91-5";
export var outline = "_91-b";
export var primaryDark = "_91-a";
export var primaryLight = "_91-8";
export var primaryModern = "_91-c";
export var success = "_91-2";
export var successSolid = "_91-3";